import dayjs from "dayjs";
import * as Yup from "yup";

export const FundAllocationSchema = Yup.object().shape({
  startDate: Yup.string().required("Start Date is required"),
  endDate: Yup.string()
    .required("End Date is required")
    .test("is-after", "End Date must be after Start Date", function (value) {
      const { startDate } = this.parent;
      return (
        !startDate ||
        !value ||
        dayjs(value, "YYYYMMDD").isAfter(dayjs(startDate, "YYYYMMDD"))
      );
    }),
  funds: Yup.array()
    .of(
      Yup.object().shape({
        purpose: Yup.string().required("Purpose is required"),
        allocationAmount: Yup.number()
          .min(1, "Allocation Amount must be at least 1")
          .required("Allocation Amount is required"),
        frequency: Yup.string().required("Frequency is required"),
        installments: Yup.number()
          .min(1, "Installments must be at least 1")
          .required("Installments are required"),
        totalAmount: Yup.number()
          .min(1, "Total Amount must be at least 1")
          .required("Total Amount is required"),
      })
    )
    .min(1, "At least one fund allocation is required"),
  // Add a general message for the whole form if needed
  // .required("Fund allocation details are required"),
});
